export const profile = {
  name: 'Sanjay Sharma',
  title: 'Software Engineer',
  email: 'sanjaysharma46071@gmail.com',
  summary:
    'A focused, self-motivated, and proactive Software Engineer specializing in backend development with extensive full-stack and cloud experience. Skilled at exploring new technologies, optimizing performance, and designing distributed systems that scale reliably.',
  highlights: ['Software Development', 'Systems Design', 'Algorithms', 'Java'],
  socials: [
    {
      id: 'github',
      label: 'GitHub',
      url: 'https://github.com/snj07',
      icon: 'CodeBracketIcon',
      handle: '@snj07',
    },
    {
      id: 'linkedin',
      label: 'LinkedIn',
      url: 'https://linkedin.com/in/sanjaysharma07',
      icon: 'BriefcaseIcon',
      handle: '/in/sanjaysharma07',
    },
    {
      id: 'stackoverflow',
      label: 'Stack Overflow',
      url: 'https://stackoverflow.com/users/4788260/',
      icon: 'RectangleStackIcon',
      handle: 'users/4788260',
    },
    // {
    //   id: 'quora',
    //   label: 'Quora',
    //   url: 'https://www.quora.com/profile/Sanjay-Sharma-250',
    //   icon: 'QuestionMarkCircleIcon',
    //   handle: 'Sanjay-Sharma-250',
    // },
    {
      id: 'facebook',
      label: 'Facebook',
      url: 'https://facebook.com/sanjaysharma07',
      icon: 'UsersIcon',
      handle: '/sanjaysharma07',
    },
    {
      id: 'instagram',
      label: 'Instagram',
      url: 'https://instagram.com/snjshrma07',
      icon: 'CameraIcon',
      handle: '@snjshrma07',
    },
    {
      id: 'topmate',
      label: 'Topmate',
      url: 'https://topmate.io/sanjaysharma/',
      icon: 'CalendarDaysIcon',
      handle: 'sanjaysharma',
    },
  ],
};